"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { TooltipProvider } from "@radix-ui/react-tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

import SignupAttributionSync from "@/components/ads/signup-attribution-sync";
import PostHogUserIdentity from "@/components/analytics/posthog-user-identity";
import GoogleTranslateGuard from "@/components/google-translate-guard";
import { getQueryClient } from "@/lib/api/query-client";
import { AppStoreProvider } from "@/store/app.store";

interface ProvidersProps {
  children: ReactNode;
}

export { getQueryClient };

export default function Providers(props: ProvidersProps) {
  const queryClient = getQueryClient();

  return (
    <ClerkProvider>
      <SignupAttributionSync />
      <GoogleTranslateGuard />
      <PostHogUserIdentity />
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={100}>
          <AppStoreProvider initialValues={{ billing: "monthly" }}>{props.children}</AppStoreProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
}
